var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 320,
    viewBox: "0 0 376 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1924_24971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68711 139.058C-2.54948 175.481 -2.25273 219.499 20.5791 245.595C43.448 271.765 88.8891 280.067 125.835 289.057C162.745 298.158 191.159 307.964 217.237 305.958C243.315 303.952 267.167 290.097 296.527 272.601C325.962 255.086 360.812 233.912 371.644 200.945C382.494 167.866 369.344 122.992 342.376 92.5879C315.464 62.2576 274.845 46.4146 237.75 31.7045C200.748 17.0315 167.233 3.39872 137.131 5.88755C106.973 8.28351 80.0791 26.6711 57.3585 50.315C34.5267 73.9217 15.8866 102.747 6.66856 139.077",
    fill: "#B2E4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.429 255.402C322.327 282.723 295.062 308.317 263.698 315.561",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.321 317.641C214.77 318.57 179.178 302.3 147.721 288.741",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.03 282.166C103.133 270.335 78.7807 261.513 61.2534 248.511",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6042 237.014C35.1945 222.044 27.2933 202.598 18.78 179.363",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8262 162.795C3.83074 137.052 -4.14463 108.208 5.16616 82.5955",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2158 67.1983C30.5576 42.2357 66.0758 22.2694 103.041 15.3787",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.511 13.187C157.626 10.1039 195.889 20.1892 231.518 30.1073",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.562 34.5835C281.003 43.9259 311.291 52.9897 331.915 68.387",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.916 79.271C359.996 97.0828 366.951 120.912 368.713 146.061",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.196 163C368.825 188.501 363.168 214.801 349.035 241.063",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.328 244.146C346.753 245.168 346.16 246.189 345.566 247.211C345.028 248.121 344.472 249.05 343.897 249.96M368.917 149.199C368.973 150.258 369.029 151.298 369.066 152.357C369.121 153.527 369.159 154.716 369.177 155.904M334.605 70.4484C335.495 71.1542 336.348 71.8972 337.201 72.6215C337.999 73.3273 338.778 74.0331 339.538 74.7389M234.672 30.943C235.729 31.2401 236.767 31.5187 237.806 31.8159C238.9 32.1131 239.976 32.4288 241.07 32.726M106.416 14.7842C107.548 14.5984 108.679 14.4313 109.792 14.2641C110.868 14.1155 111.944 13.9669 113.019 13.8369M6.4646 79.2708C6.92828 78.175 7.42906 77.0977 7.96694 76.0204C8.46772 74.9989 9.00559 73.9959 9.58056 72.993M17.6116 176.112C17.2221 175.035 16.8326 173.958 16.4431 172.88C16.035 171.766 15.627 170.652 15.2375 169.519M58.5827 246.431C57.6925 245.706 56.8207 244.982 55.9676 244.239C55.0958 243.478 54.2426 242.716 53.4266 241.936M144.643 287.422C143.604 286.976 142.565 286.531 141.545 286.103C140.488 285.658 139.431 285.212 138.392 284.785M260.601 316.229C259.544 316.434 258.486 316.601 257.429 316.768C256.316 316.935 255.203 317.084 254.091 317.195",
    stroke: "#AEB9CB",
    strokeWidth: 1.81818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.767 317.214C183.555 317.214 178.658 315.19 175.005 311.531L37.4572 173.791C33.8034 170.132 31.7817 165.229 31.7817 160.009C31.7817 154.79 33.8034 149.887 37.4572 146.228L175.005 8.46957C178.658 4.81063 183.555 2.78613 188.767 2.78613C193.979 2.78613 198.875 4.81063 202.529 8.46957L340.076 146.209C343.73 149.868 345.752 154.772 345.752 159.991C345.752 165.21 343.73 170.113 340.076 173.772L202.529 311.512C198.875 315.171 193.979 317.196 188.767 317.196V317.214Z",
    fill: "#EA0A8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.767 5.572C193.237 5.572 197.428 7.29932 200.563 10.4382L338.11 148.178C344.62 154.697 344.62 165.303 338.11 171.822L200.563 309.562C197.428 312.701 193.237 314.428 188.767 314.428C184.297 314.428 180.105 312.701 176.97 309.562L39.4231 171.822C32.913 165.303 32.913 154.697 39.4231 148.178L176.97 10.4382C180.105 7.29932 184.297 5.572 188.767 5.572ZM188.767 0C183.054 0 177.36 2.17308 173.02 6.50067L35.4911 144.241C26.8295 152.914 26.8295 167.086 35.4911 175.759L173.038 313.499C177.36 317.827 183.073 320 188.785 320C194.498 320 200.192 317.827 204.532 313.499L342.079 175.759C350.741 167.086 350.741 152.914 342.079 144.241L204.513 6.50067C200.192 2.17308 194.479 0 188.767 0Z",
    fill: "#1E184F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.697 32.2969L61.2488 152.913C57.3375 156.83 57.3375 163.181 61.2488 167.097L181.684 287.701C185.595 291.618 191.937 291.618 195.848 287.701L316.296 167.084C320.207 163.167 320.207 156.817 316.296 152.9L195.861 32.2968C191.95 28.38 185.608 28.3801 181.697 32.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.377 99.7573H164.637L160.426 113.334H216.662L212.377 99.7573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.931 133.171H154.269L150.281 146.079H226.993L222.931 133.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.005 179.159H237.435L233.262 165.916H144.123L140.024 179.159H142.528H235.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.993 146.079H150.281L144.123 165.916H233.262L226.993 146.079Z",
    fill: "#FAB041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.662 113.334H160.426L154.269 133.171H222.931L216.662 113.334Z",
    fill: "#FAB041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.109 79.9026H170.776L164.637 99.7575H212.378L206.109 79.9026Z",
    fill: "#FAB041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.23 192.383H129.322C125.353 192.383 122.719 195.02 122.719 198.995V210.9C122.719 211.569 123.387 212.219 124.036 212.219H253.516C254.183 212.219 254.832 211.55 254.832 210.9V198.995C254.832 195.02 252.199 192.383 248.23 192.383Z",
    fill: "#FAB041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.435 179.158H235.005H142.528H140.024L135.925 192.383H241.627L237.435 179.158Z",
    fill: "#FAB041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3002 162.442C90.4285 169.37 92.6357 176.614 97.9587 181.944C104.914 188.909 115.152 190.562 123.665 186.903L123.777 187.015L136.055 199.31L173.428 236.754C172.464 241.676 173.892 246.97 177.694 250.777C183.777 256.869 193.626 256.869 199.71 250.777C205.793 244.685 205.793 234.823 199.71 228.731C195.907 224.923 190.621 223.493 185.706 224.459L148.333 187.015L136.055 174.719L135.925 174.589C139.579 165.99 137.854 155.607 130.825 148.698C125.52 143.498 118.361 141.325 111.517 142.197C110.979 142.272 110.756 142.922 111.146 143.312L120.475 152.654C121.124 153.304 121.384 154.252 121.143 155.143L118.027 166.677C117.786 167.55 117.137 168.219 116.265 168.479L104.265 172.026C103.356 172.286 102.373 172.026 101.724 171.376L92.4131 162.052C92.0236 161.662 91.3744 161.885 91.3002 162.424V162.442ZM184.315 235.361C186.745 232.928 190.659 232.928 193.088 235.361C195.518 237.794 195.518 241.713 193.088 244.146C190.659 246.58 186.745 246.58 184.315 244.146C181.886 241.713 181.886 237.794 184.315 235.361Z",
    fill: "#1E184F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1924_24971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375.455,
    height: 320,
    fill: "white",
    transform: "translate(0.54541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/under-construction.3d73be66d4acbe67697bd2ea53934ed0.svg";
export { ForwardRef as ReactComponent };